import React, { useContext, useState } from "react";
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { Outlet, useParams } from "react-router-dom"
import jwt_decode from "jwt-decode";
import CountdownTimer from "../helpers/CountdownTimer";
import { PCErrorBlack } from "../assets/icons/dashboard";
import ButtonProgreso from '../components/buttons/Button'
import { WEB_PROGRESO } from "../helpers/url";
import { ModalWebPagos } from "../components/modal/Modal"
import { TextColored, Text } from "../components/typography"
import { ThemeContext } from "../theming";


const WebMain = ({ headers = false }) => {
    let { rut } = useParams();
    const container = {
        // borderRightWidth: "50px",
        // borderRightColor: "black",
        // borderRightStyle: "solid",
        width: "100%",
        display: "flex",
        justifyContent: "center",
    };
    const app = useContext(ThemeContext);
    const { body25, body28, body32 } = app.theme.font;
    let token = localStorage.getItem('t');
    let token_data = null;
    if(token){
        token_data = jwt_decode(token);
        
    }
    const timeRemaining = token_data?(token_data.exp * 1000 - Date.now()):(16001);
    const [tiempoRestante, setTiempoRestante] = useState(timeRemaining);
    const [showModalError, setShowModalError] = useState(false);

    const ButtonTry = ()=><a href={WEB_PROGRESO}>
    <ButtonProgreso sizeText={1} styleText={{ fontWeight : "600"}}>
        Volver al intentar
    </ButtonProgreso>
</a>
const ticktock = (time)=>{
    /* setModalData({
        ...modalData,
        message: "Está por terminar su sesión, le falta " + Math.round( time / 1000 ) + " segundo(s).",
    })    
    if(time <= 15000 && !showModalError){
        handleShowModalError();
    } */
}
    const [modalData, setModalData] = useState({
            messageLine: false,
            //title: "Pagar contratos",
            color: "red",
            //subtitle: "Error",
            message: "Está por terminar su sesión, le falta " + 15 + " segundo(s).",
            icon: (
                <>
                    <PCErrorBlack />
                </>
            ),
            buttonTry : ()=><ButtonTry message={"Seguir en webPagos"}/>
    });

    const handleCloseModalError = () => { setShowModalError(false) };
    const handleShowModalError = () => { setShowModalError(true) }

    const completeTimer = ()=>{
        
        window.location.href = "/sesion/caducada";
    }
    
    return (
        <>
            <CountdownTimer timeLeft={timeRemaining} completeCallback={completeTimer} tickCallback={ticktock}/>
            <section style={{ width: "100%" }}>
                {headers && <Header />}
                <div style={container}>
                    <Outlet context={{ rut, headers }} />
                    <ModalWebPagos
                show={showModalError}
                icon={modalData.icon}
                headerTitle="Pago en Línea"
                messageLine={modalData.messageLine}
                title={
                    <TextColored size={body28} type={modalData.color}>
                        {modalData.title}
                    </TextColored>
                }
                subtitle={
                    <TextColored size={body32} bold type={modalData.color}>
                        {modalData.subtitle}
                    </TextColored>
                }
                message={
                    <Text type="primary" size={body25} style={{ fontWeight : "600"}}>
                        {modalData.message}
                    </Text>
                }
                handleClose={handleCloseModalError}
                ButtonTry={modalData.buttonTry}
            />
                </div>
                {headers && <Footer />}
            </section>
        </>
    )
}
export default WebMain;